import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection'
import { $createNodeSelection, $setSelection, CLICK_COMMAND, COMMAND_PRIORITY_LOW, type NodeKey } from 'lexical'
import { cn } from '@/utils/index.ts'

export function ContractVariableToken({ nodeKey, text }: { nodeKey: NodeKey; text: string }) {
  const [editor] = useLexicalComposerContext()
  const [selected] = useLexicalNodeSelection(nodeKey)
  useEffect(
    () =>
      editor.registerCommand(
        CLICK_COMMAND,
        (event) => {
          const element = editor.getElementByKey(nodeKey)
          if (!editor.isEditable() || !(event.target instanceof Node) || !element?.contains(event.target)) {
            return false
          }
          editor.getRootElement()?.focus({ preventScroll: true })
          const selection = $createNodeSelection()
          selection.add(nodeKey)
          $setSelection(selection)
          return true
        },
        COMMAND_PRIORITY_LOW
      ),
    [editor, nodeKey]
  )
  return (
    <span className={cn('text-accent rounded bg-[var(--accent-soft)] px-1', selected && 'outline-accent outline-2')}>
      {text}
    </span>
  )
}
